import { Language, TemplateSubType, TemplateType } from '../../../types/dto-app';

export const leaseUnpaidAmountSecondReminderTemplates = [
  {
    id: '-228001',
    language: Language.EN,
    subject: 'Reminder 2: Unpaid amount',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_SECOND_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Dear tenant,</p>
          {{#if isPartiallyPaid}}
          <p>A remaining balance of {{totalAmount}} € is still unpaid (original amount: {{amountTotal}} €, already paid: {{amountPaid}} €).</p>
          {{else}}
          <p>An amount of {{totalAmount}} € remains unpaid.</p>
          {{/if}}
          {{#if thirdReminderEnabled}}
          <p>It is the second reminder: {{pdfLink}}.</p>
          {{else}}
          <p>It is the second reminder before formal notice: {{pdfLink}}.</p>
          {{/if}}
          <p>Kind regards.</p>
      `,
  },
  {
    id: '-228002',
    language: Language.FR,
    subject: 'Rappel 2: Montant impayé',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_SECOND_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Cher/Chère locataire,</p>
          {{#if isPartiallyPaid}}
          <p>Un solde restant de {{totalAmount}} € demeure impayé (montant initial : {{amountTotal}} €, déjà payé : {{amountPaid}} €).</p>
          {{else}}
          <p>Le montant de {{totalAmount}} € demeure impayé.</p>
          {{/if}}
          {{#if thirdReminderEnabled}}
          <p>C'est le deuxième rappel: {{pdfLink}}.</p>
          {{else}}
          <p>C'est le deuxième rappel avant la mise en demeure: {{pdfLink}}.</p>
          {{/if}}
          <p>Bien à vous.</p>
      `,
  },
  {
    id: '-228003',
    language: Language.NL,
    subject: 'Herinnering 2: Onbetaald bedrag',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_SECOND_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Beste huurder,</p>
          {{#if isPartiallyPaid}}
          <p>Een resterend saldo van {{totalAmount}} € blijft onbetaald (oorspronkelijk bedrag: {{amountTotal}} €, reeds betaald: {{amountPaid}} €).</p>
          {{else}}
          <p>Een bedrag van {{totalAmount}} € blijft onbetaald.</p>
          {{/if}}
          {{#if thirdReminderEnabled}}
          <p>Het is de tweede herinnering: {{pdfLink}}.</p>
          {{else}}
          <p>Het is de tweede herinnering vóór de ingebrekestelling: {{pdfLink}}.</p>
          {{/if}}
          <p>Groeten.</p>
      `,
  },
  {
    id: '-228004',
    language: Language.DE,
    subject: 'Erinnerung 2: Unbezahlter Betrag',
    type: TemplateType.SMS,
    subType: TemplateSubType.LEASE_UNPAID_AMOUNT_SECOND_REMINDER,
    clientId: 'Template#-1',
    readId: 'R#Template#-1',
    body: `
          <p>Liebe/r Mieter/in,</p>
          {{#if isPartiallyPaid}}
          <p>Ein verbleibender Restbetrag von {{totalAmount}} € ist noch unbezahlt (Ursprungsbetrag: {{amountTotal}} €, bereits bezahlt: {{amountPaid}} €).</p>
          {{else}}
          <p>Ein Betrag von {{totalAmount}} € ist noch unbezahlt.</p>
          {{/if}}
          {{#if thirdReminderEnabled}}
          <p>Dies ist die zweite Mahnung: {{pdfLink}}.</p>
          {{else}}
          <p>Dies ist die zweite Mahnung vor der förmlichen Aufforderung: {{pdfLink}}.</p>
          {{/if}}
          <p>Mit freundlichen Grüßen.</p>
      `,
  },
];
